/**
 * Die Chronik im Kundenkonto: Belege (`dokument`), Einsatztermine (`termin`),
 * die Projektakte der Projekte dieses Kunden (`projekt`) und die Post — alles
 * nur gelesen. `typ` ist zugleich der Filter in der Oberfläche.
 *
 * Eigene Notizen und Aufgaben stehen seit Migration 162 in `notiz` (je Konto,
 * `lib/notizen.ts`) und über der Chronik im Block „Notizen & Aufgaben".
 */

/** Quelle einer Verlaufszeile — der Filter läuft über dieses Feld. */
export type VerlaufQuelle = "dokument" | "termin" | "projekt" | "post";

/** Eine Zeile der Chronik. */
export type VerlaufEintrag = {
  id: string;
  typ: VerlaufQuelle;
  untertyp: string;
  titel: string;
  text: string;
  zeitpunkt: string;
  projekt_id?: string;
  projekt_titel?: string;
  akte_label?: string;
  dokumentart?: string;
  netto?: number;
  ende?: string;
};

export type KundeAkte = {
  kunde_id: string;
  verlauf: VerlaufEintrag[];
};

/** Beschriftung der Filterleiste. `null` = kein Filter. */
export const VERLAUF_FILTER: { id: VerlaufQuelle | null; label: string }[] = [
  { id: null, label: "Alles" },
  { id: "dokument", label: "Belege" },
  { id: "termin", label: "Termine" },
  { id: "projekt", label: "Projekt" },
  // Kein „Post" mehr (04.10.2026): Mails stehen im Nachrichtenfenster.
];

/** `2026-08-31` → `31.08.2026`. Gibt die Eingabe zurück, wenn sie nicht passt. */
export function tagDe(wert: string): string {
  const teile = (wert || "").slice(0, 10).split("-");
  if (teile.length === 3 && teile.every((t) => /^\d+$/.test(t))) {
    return `${teile[2]}.${teile[1]}.${teile[0]}`;
  }
  return wert || "";
}
